/* dace studio – Bewegungen: Telefon-Film, Design-Wechsel, Pausentimer, Wort-Effekt */
(function () {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = s => document.querySelector(s);
  const film = $(".film"), phoneWrap = $("#phoneWrap"), st = $("#statement");

  /* Wort-Effekt vorbereiten */
  let words = [];
  if (st) {
    (function split(node) {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(w => {
            if (!w.trim()) { frag.appendChild(document.createTextNode(w)); return; }
            const s = document.createElement("span"); s.className = "w" + (node.classList && node.classList.contains("red") ? " red" : ""); s.textContent = w; frag.appendChild(s);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) split(n);
      });
    })(st);
    words = [...st.querySelectorAll(".w")];
  }
  function lightWords() {
    if (!st) return;
    const r = st.getBoundingClientRect(), vh = innerHeight;
    const p = Math.min(1, Math.max(0, (vh * .85 - r.top) / (r.height + vh * .35)));
    const n = reduce ? words.length : Math.round(p * words.length);
    words.forEach((w, i) => w.classList.toggle("lit", i < n));
  }
  function onScroll() {
    const vh = innerHeight;
    if (film && phoneWrap) {
      const f = film.getBoundingClientRect();
      const q = Math.min(1, Math.max(0, (vh - f.top) / (vh * .9)));
      phoneWrap.style.setProperty("--tilt", ((1 - q) * 24).toFixed(2) + "deg");
      phoneWrap.style.setProperty("--pscale", (.84 + q * .16).toFixed(3));
    }
    lightWords();
  }
  if (reduce) lightWords(); else { addEventListener("scroll", () => requestAnimationFrame(onScroll), { passive: true }); onScroll(); }

  /* Telefon-Film: Text-Schritt im Blick steuert den Bildschirm */
  const steps = [...document.querySelectorAll(".step")];
  const views = [...document.querySelectorAll(".view")];
  const tabs = [...document.querySelectorAll("#tabbar span")];
  const screen = $("#screen"), themeBox = $("#themes");
  if (!steps.length || !screen) return;
  const tabFor = [0, 1, 2, 4, 4];
  const band = matchMedia("(max-width: 860px)").matches ? "-78% 0px -12% 0px" : "-45% 0px -45% 0px";
  const THEMES = [
    ["Standard", "#0b0c0e", "#15171a", "#c6f24e", "#f2f3f5"], ["Dunkel · Volt", "#0b0c0e", "#15171a", "#c6f24e", "#f2f3f5"],
    ["Hell", "#f2f3f5", "#ffffff", "#b8e62e", "#0f1216"], ["Papier", "#F5F3EE", "#FBFAF6", "#1E3A2F", "#14251E"],
    ["AMOLED", "#000000", "#0b0b0c", "#c6f24e", "#f5f5f7"], ["Glas", "#0a0f1c", "#1a2236", "#0a84ff", "#f5f7fb"],
    ["Wald", "#0b1411", "#13221b", "#C99A5B", "#eef3ef"], ["Sonnenuntergang", "#130b10", "#211319", "#ff7a59", "#fbf0ee"],
    ["Ozean", "#07121b", "#0e1f2d", "#35d0c4", "#eaf4fb"], ["Lila-Nacht", "#0e0a18", "#181229", "#b79cff", "#f3effc"],
    ["Mono", "#0c0c0c", "#171717", "#eceef1", "#f0f0f0"], ["Terminal", "#040804", "#070d07", "#39ff6a", "#b9f7c5"]];
  if (themeBox) THEMES.forEach(t => {
    const d = document.createElement("div");
    d.className = "th"; d.style.background = t[1]; d.style.color = t[4];
    d.innerHTML = `<i style="background:${t[3]}"></i><span>${t[0]}</span>`;
    themeBox.appendChild(d);
  });
  const dots = $("#dots");
  if (dots) THEMES.forEach((t, k) => { const i = document.createElement("i"); i.style.setProperty("--d1", t[1]); i.style.setProperty("--d2", t[3]); i.style.setProperty("--k", k); dots.appendChild(i); });
  let baseTheme = 6, running = false, timer = null, ti = 6;
  function applyTheme(t) {
    const light = t[1].toLowerCase() > "#e";
    screen.style.setProperty("--app-bg", t[1]); screen.style.setProperty("--app-card", t[2]);
    screen.style.setProperty("--app-accent", t[3]); screen.style.setProperty("--app-text", t[4]);
    screen.style.setProperty("--app-muted", light ? "rgba(15,18,22,.55)" : "rgba(238,243,239,.55)");
    if (themeBox) [...themeBox.children].forEach(c => c.classList.toggle("on", c.lastChild.textContent === t[0]));
  }
  const syncBase = () => { baseTheme = (window.dace && window.dace.mode() === "light") ? 3 : 6; if (!running) applyTheme(THEMES[baseTheme]); };
  document.addEventListener("dace:mode", syncBase);
  function show(i) {
    steps.forEach((s, k) => s.classList.toggle("is-on", k === i));
    views.forEach((v, k) => v.classList.toggle("is-on", k === i));
    tabs.forEach((t, k) => t.classList.toggle("on", k === tabFor[i]));
  }
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) show(+e.target.dataset.step); }), { rootMargin: band });
  steps.forEach(s => io.observe(s));
  const last = document.querySelector('.step[data-step="4"]');
  if (last) new IntersectionObserver(es => es.forEach(e => {
    clearInterval(timer); running = false;
    if (e.isIntersecting && !reduce) { running = true; ti = baseTheme; timer = setInterval(() => { ti = (ti + 1) % THEMES.length; applyTheme(THEMES[ti]); }, 1100); }
    else applyTheme(THEMES[baseTheme]);
  }), { rootMargin: band }).observe(last);
  syncBase();

  const tmr = $("#tmr");
  let secs = 105;
  if (tmr && views[2]) setInterval(() => {
    if (!views[2].classList.contains("is-on") || reduce) return;
    secs = secs <= 0 ? 180 : secs - 1;
    tmr.textContent = Math.floor(secs / 60) + ":" + String(secs % 60).padStart(2, "0");
  }, 1000);
})();
